import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Timestamp} from '@angular/fire/firestore';
import {AngularFirestore} from "@angular/fire/compat/firestore";
import {MatTableDataSource} from "@angular/material/table";
import {MatSort} from "@angular/material/sort";
import {PermissionType} from "../../../../components/employee/PermissionType.enum";
import {FormControl} from "@angular/forms";
import firebase from "firebase/compat";
import {Observable, Subject} from "rxjs";
import {CentreOption} from "../../../../interfaces/Centres";
import {CentreService} from "../../../../services/centre.service";
import {MatPaginator} from "@angular/material/paginator";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import {map, takeUntil} from "rxjs/operators";
import {AngularFireDatabase} from "@angular/fire/compat/database";
import {HospitalService} from "../../../../services/hospital.service";
import {Hospitals} from "../../../../interfaces/Hospitals";
import {FinancialYearService} from "../../../../services/financial-year.service";

export interface AdmissionLogHistory {
  admissionCount: number;
  admissionId: string;
  childCode: string;
  age: number;
  dob: Timestamp;
  gender: string;
  bloodGroup: string;
  centreCode: string;
  centreName: string;
  currentUnit: string;
  city: string;
  state: string;
  hospital: string;
  diagnosis: string[];
  guardian1Name: string;
  guardian1Occupation: string;
  guardian1Relation: string;
  guardian2Name?: string;
  guardian2Occupation?: string;
  guardian2Relation?: string;
  dateOfAdmission: Timestamp;
  createdAt: Timestamp;
  createdBy: string;
  isUnique: boolean;
  type: AdmissionType;
}


export type AdmissionType =
  | 'Admission'
  | 'Discharge'
  | 'FollowUpAdmission'
  | 'FollowUpDischarge'
  | 'Transfer';

@Component({
  selector: 'app-addmission-log-history',
  templateUrl: './addmission-log-history.component.html',
  styleUrls: ['./addmission-log-history.component.scss']
})
export class AddmissionLogHistoryComponent implements OnInit, AfterViewInit, OnDestroy {
  private readonly _destroyed$ = new Subject<void>();
  startDate1!: Date | null;
  endDate1!: Date | null;
  selectedCentre:any;
  selectedGender = 'All';
  typeSelected ='All';

  //
  allData: AdmissionLogHistory[] = [];
  filteredData: AdmissionLogHistory[] = [];
//
  selectedHospital:any;
  selectedLocation:any;
  selectedDiagnosis: { name: string }[] = [];
  displayedColumns: string[] = [
    'srNo',
    'admissionCount',
    'childName',
    'childCode',
    'centreName',
    'dateOfAdmission',
    'hospital',
    'type'
  ];
  columnSearchControl = new FormControl('');
  dataSource = new MatTableDataSource<AdmissionLogHistory>([]);
  isLoading = false;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  centres$!: Observable<CentreOption[]>;
  columnLabelMap: { [key: string]: string } = {};
  dynamicColumns = [
    { value: 'srNo', label: 'Sr No' },
    { value: 'admissionCount', label: 'Admission Count' },
    { value: 'childName', label: 'Child Name' },
    { value: 'childCode', label: 'Child Code' },
    { value: 'age', label: 'Age' },
    { value: 'gender', label: 'Gender' },
    { value: 'bloodGroup', label: 'Blood Group' },
    { value: 'centreCode', label: 'Centre Code' },
    { value: 'centreName', label: 'Centre Name' },
    { value: 'currentUnit', label: 'Current Unit' },
    { value: 'city', label: 'City' },
    { value: 'state', label: 'State' },
    { value: 'hospital', label: 'Hospital' },
    { value: 'diagnosis', label: 'Diagnosis' },
    { value: 'guardian1Name', label: 'Guardian Name' },
    { value: 'guardian1Relation', label: 'Guardian Relation' },
    { value: 'guardian1Occupation', label: 'Guardian Occupation' },
    { value: 'dateOfAdmission', label: 'Date Of Admission' },
    { value: 'createdBy', label: 'Created By' },
    { value: 'type', label: 'Admission Type' }
  ];
  states: string[] = [
    'Andhra Pradesh',
    'Arunachal Pradesh',
    'Assam',
    'Bihar',
    'Chhattisgarh',
    'Goa',
    'Gujarat',
    'Haryana',
    'Himachal Pradesh',
    'Jharkhand',
    'Karnataka',
    'Kerala',
    'Madhya Pradesh',
    'Maharashtra',
    'Manipur',
    'Meghalaya',
    'Mizoram',
    'Nagaland',
    'Odisha',
    'Punjab',
    'Rajasthan',
    'Sikkim',
    'Tamil Nadu',
    'Telangana',
    'Tripura',
    'Uttar Pradesh',
    'Uttarakhand',
    'West Bengal'
  ];

  selectedBloodGroup: string = 'All';

  bloodGroups: string[] = [
    'A+ve','A-ve',
    'B+ve','B-ve',
    'O+ve','O-ve',
    'AB+ve','AB-ve',
    'NA'
  ];
//dropdown
  displayHospital = (h: any) => h.hospitalName;
  hospitalOptions: any[] = [];
  childCodeOptions: string[] = [];
  diagnosisOptions: any[] = [];
  stateOptions: string[] = [];
  _diagnosis$: Observable<String[]>;
  displayState = (s:any) => s;

  filteredDynamicColumns = [...this.dynamicColumns];
  displayCentre = (c: any) => c?.centreName;
  displayDiagnosis = (d: any) => d;
  constructor(private firestore: AngularFirestore,
              private mCentreService: CentreService,
              private hospitalService : HospitalService,
              private readonly financialYearService: FinancialYearService,
              private mDataBase : AngularFireDatabase) {
    this.centres$ = this.mCentreService.getAllCentres();
    this._diagnosis$ = this.mDataBase.list<String>('types/Diagnosis').valueChanges().pipe(
      map(diagnosis => diagnosis.map(d => d.toString()).sort((a, b) => a.localeCompare(b)))
    );
  }
  ngOnInit() {
    const fy = this.financialYearService.getCurrentFinancialYear();
    this.startDate1 = fy.startDate;
    this.endDate1 = fy.endDate;
    this.dynamicColumns.forEach(col => {
      this.columnLabelMap[col.value] = col.label;
    });
    // this.loadDataOnce();
    this.GetAllHospitals()
    this.dataSource.data = [];
  }

  GetAllHospitals() {
    this.hospitalService.getHospitalList().pipe(takeUntil(this._destroyed$)).subscribe((res: any[]) => {
      this.hospitalOptions = res;
    });
  }

  loadDataOnce() {
    this.firestore.collection<AdmissionLogHistory>(
      'AdmissionLogHistory')
      .valueChanges({ idField: 'admissionId' })
      .pipe(takeUntil(this._destroyed$))
      .subscribe({
        next: res => {
          this.allData = res;
          console.log(this.allData);
          this.filteredData = res;
          this.buildDropdownOptions(res);
          this.isLoading = false;
        },
        error: err => {
          console.error(err);
          this.isLoading = false;
        }
      });
  }
  buildDropdownOptions(data: AdmissionLogHistory[]) {
    this.hospitalOptions = [...new Set(data.map(d => d.hospital).filter(Boolean))];
    this.childCodeOptions = [...new Set(data.map(d => d.childCode).filter(Boolean))];
    this.stateOptions = [...new Set(data.map(d => d.state).filter(Boolean))];
    this.diagnosisOptions = [
      ...new Set(
        data.flatMap(d =>
          Array.isArray(d.diagnosis)
            ? d.diagnosis.filter(dx => dx.length > 0)
            : []
        )
      )
    ].map(d => ({ name: d }));


    console.log('Diagnosis options:', this.diagnosisOptions);

  }

  ngAfterViewInit() {
    this.columnSearchControl.valueChanges.pipe(takeUntil(this._destroyed$)).subscribe(value => {
      const filter = value?.toLowerCase() || '';
      this.filteredDynamicColumns = this.dynamicColumns.filter(col =>
        col.label.toLowerCase().includes(filter)
      );
    });
  }
  onCentreSelect(selectedCentres: any[]) {
    this.selectedCentre = selectedCentres;
  }
  onColumnsSelected(event: any) {
    this.displayedColumns = event.value;
  }

  onDiagnosisSelect(diagnosis: { name: string }[]) {
    this.selectedDiagnosis = diagnosis;
  }

  onStateSelect(state: any) {
    this.selectedLocation = state;
  }
  resetColumnFilter() {
    this.filteredDynamicColumns = [...this.dynamicColumns];
  }

  dynamicQuery() {
    if (!this.startDate1 || !this.endDate1) {
      alert('Please select date range');
      return;
    }

    this.isLoading = true;

    const start = Timestamp.fromDate(
      new Date(this.startDate1.setHours(0, 0, 0, 0))
    );
    const end = Timestamp.fromDate(
      new Date(this.endDate1.setHours(23, 59, 59, 999))
    );

    this.firestore.collection<AdmissionLogHistory>(
      'AdmissionLogHistory',
      ref => {
        let q: firebase.firestore.Query = ref;
        q = q
          .where('dateOfAdmission', '>=', start)
          .where('dateOfAdmission', '<=', end)
          .orderBy('dateOfAdmission', 'desc');
        if (this.selectedCentre?.length) {
          const centreCodes = this.selectedCentre.map(
            (c: any) => c.centreCode
          );

          if (centreCodes.length <= 10) {
            q = q.where('centreCode', 'in', centreCodes);
          } else {
            //  Select All case → DO NOT APPLY centre filter
            console.log('All centres selected → loading all centres');
          }
        }

        // GENDER
        if (this.selectedGender && this.selectedGender !== 'All') {
          q = q.where('gender', '==', this.selectedGender);
        }

        // STATE
        if (this.selectedLocation && this.selectedLocation !== 'All') {
          q = q.where('state', '==', this.selectedLocation);
        }

        if (this.selectedHospital?.length) {
          const hospitals = this.selectedHospital.map(
            (h: any) => h.hospitalName
          );
          if (hospitals.length <= 10) {
            q = q.where('hospital', 'in', hospitals);
          }
        }

        // TYPE
        if (this.typeSelected && this.typeSelected !== 'All') {
          q = q.where('type', '==', this.typeSelected);
        }

        // DIAGNOSIS
        if (this.selectedDiagnosis.length) {
          const diagnoses = this.selectedDiagnosis.map(d => d.name);

          if (diagnoses.length <= 10) {
            q = q.where(
              'diagnosis',
              'array-contains-any',
              diagnoses
            );
          }
        }


        if (this.selectedBloodGroup !== 'All') {
          q = q.where('bloodGroup', '==', this.selectedBloodGroup);
        }

        return q;
      }
    )
      .valueChanges({ idField: 'admissionId' })
      .pipe(takeUntil(this._destroyed$))
      .subscribe({
        next: res => {
          this.dataSource.data = res;
          this.dataSource.sort = this.sort;
          this.dataSource.paginator = this.paginator;
          this.isLoading = false;
        },
        error: err => {
          console.error(err);
          this.isLoading = false;
        }
      });
  }

  // TABLE SEARCH
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  onHospitalSelect(hospitals: any[]) {
    this.selectedHospital = hospitals;
    console.log(this.selectedHospital);
  }

  exportexcel() {
    if (!this.dataSource.data.length) {
      alert('No data to export');
      return;
    }

    const exportData = this.dataSource.data.map((row, index) => {
      const record: any = {};

      this.dynamicColumns.forEach(col => {
        const label = col.label;
        const key = col.value;

        switch (key) {
          case 'srNo':
            record[label] = index + 1;
            break;

          case 'dateOfAdmission':
            record[label] = row.dateOfAdmission
              ? row.dateOfAdmission.toDate().toLocaleDateString()
              : '';
            break;

          case 'diagnosis':
            record[label] = Array.isArray(row.diagnosis)
              ? row.diagnosis.join(', ')
              : '';
            break;

          default:
            record[label] = (row as any)[key] ?? '';
        }
      });

      return record;
    });

    // Convert JSON → worksheet
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(exportData);

    // Optional: auto column width
    worksheet['!cols'] = this.dynamicColumns.map(() => ({ wch: 25 }));

    // Create workbook
    const workbook: XLSX.WorkBook = {
      Sheets: { 'Admission Report': worksheet },
      SheetNames: ['Admission Report']
    };

    // Generate Excel file
    const excelBuffer = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array'
    });

    // Save file
    const blob = new Blob([excelBuffer], {
      type:
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
    });

    saveAs(blob, `Admission_Report_${new Date().getTime()}.xlsx`);
  }


  onEndDateChanged() {
  }
  clearAll() {
    const fy = this.financialYearService.getCurrentFinancialYear();
    this.startDate1 = fy.startDate;
    this.endDate1 = fy.endDate;
    this.selectedCentre = [];
    this.selectedGender = 'All';
    this.typeSelected = 'All';
    this.selectedBloodGroup = 'All';
    this.selectedHospital = [];
    this.selectedLocation = null;
    this.selectedDiagnosis = [];
    this.dataSource.data = [];
    if (this.paginator) {
      this.paginator.firstPage();
    }
    this.dataSource.sort = this.sort;
  }

  protected readonly PermissionType = PermissionType;

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }
}
